// src/App.js
import React from 'react';
import firebaseConfig from './firebaseConfig.json';
import paymentConfig from './paymentConfig.json';
import authMethods from "./authMethods.json";
import pathnames from './components/pathnames.json';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthContext, AuthProvider, AuthRoutes } from "./components/Auth";
import {AppProvider} from './components/AppProvider';
import { Typography, Box, Grid, CircularProgress } from '@mui/material';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { SignIn, SignUp, ResetPassword } from "./pages/auth";
import {UserProfile, UserUpdateName, UserUpdatePassword, UserDelete} from './pages/user';
import CoverPage from './pages/CoverPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import StripeOnboardingRefreshPage from './pages/StripeOnboardingRefreshPage';
import StripeOnboardingReturnPage from './pages/StripeOnboardingReturnPage';
import {AdminPanel, AdminWebsiteUsers} from './components/admin';
import ContactPage from './pages/Contact';
import ChannelsPage from './pages/ChannelsPage';
import DashboardPage from './pages/DashboardPage';
import IosAppPage from './pages/IosAppPage';
import ResponsiveAppBar from './components/ResponsiveAppBar';
import { AppTemplate, PublicTemplate } from './templates';
import Logo from './components/Logo';
import ScrollToTop from './components/ScrollToTop';
import {AdminPageProvider} from './components/admin/AdminPageContext';

const AppLogo = ({size}) => {
    let cpSize = 32;
    switch(size){
        case "small":
            cpSize = 32;
            break;
        case "medium":
            cpSize = 48;
            break;
        case "large":
            cpSize = 64;
            break;
        default:
            cpSize = 32;
            break;
    }
    return (
        <div
              style={{
                  width: cpSize,
                  //height: cpSize,
                  overflow: "hidden",
                  position: "relative",
                  //borderRadius: "50%", // if you want a circular clipping container
                  //border: "1px solid #000" // optional: visible border
              }}
              >
                  <img src="/logo-4.png" alt="CCOO Logo" style={{ width: '100%', height: '100%' }} />
          </div>
    );
}

const Loader = ({size}) => {
  let cpSize = "60px";
  switch(size){
      case "small":
          cpSize = "30px";
          break;
      case "medium":
          cpSize = "35px";
          break;
      case "large":
          cpSize = "60px";
          break;
      default:
          cpSize = "35px";
          break;
  }
  return (
      <Box sx={{ mt: 5, display: 'flex', justifyContent: "center", alignItems: "center"}}>
          <CircularProgress color="warning" size={cpSize} />
          <div style={{position: "absolute" }}>
              <AppLogo size={size} />
          </div>
      </Box>
  );
}

function App() {
  const config = {
		brand: "GGC.me",
    firebaseConfig: firebaseConfig,
    pathnames: pathnames,
    authProviders: authMethods,
    paymentConfig: paymentConfig
	}

  const themeLight = createTheme({
    palette: {
      primary: {
          main: "#0A1532"
      }
    },
    typography: {
      button: {
        textTransform: 'none'
      }
    }
  });

  return (
    <ThemeProvider theme={themeLight}>
      <AppProvider config={config}>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<AuthRoutes loader={<Loader size="large" />} />} >
                <Route element={<AppTemplate />}>
                  <Route exact path={pathnames.Home} element={<CoverPage />} />
                  <Route exact path={pathnames.About} element={<AboutPage />} />
                  <Route exact path={pathnames.PrivacyPolicy} element={<PrivacyPolicyPage />} />
                  <Route exact path={pathnames.TermsOfService} element={<TermsOfServicePage />} />
                  <Route exact path={pathnames.IosApp} element={<IosAppPage />} />
                  <Route exact path={pathnames.Contact} element={<ContactPage />} />
                  <Route exact path={pathnames.Channels} element={<ChannelsPage />} />
                  <Route exact path={pathnames.Dashboard} element={<DashboardPage />} />
                  <Route exact path={pathnames.UserProfile} element={<UserProfile />} />
                  <Route path={pathnames.Admin} element={<AdminPageProvider />} >
                    <Route exact path={pathnames.Admin} element={<AdminPanel />} />
                    <Route exact path={pathnames.AdminWebsiteUsers} element={<AdminWebsiteUsers />} />
                  </Route>
                </Route>
              </Route>
            </Routes>
            <Routes>
              <Route element={<PublicTemplate />}>
                <Route path={pathnames.SignIn} element={
                  <SignIn
                    logo={<AppLogo size="large" />}
                  />
                } />
                <Route path={pathnames.SignUp} element={
                  <SignUp
                    logo={<AppLogo size="large" />}
                  />
                } />
                <Route path={pathnames.ResetPassword} element={
                  <ResetPassword
                    logo={<AppLogo size="large" />}
                  />
                } />
                <Route exact path={pathnames.StripeOnboardingRefresh} element={<StripeOnboardingRefreshPage />} />
                <Route exact path={pathnames.StripeOnboardingReturn} element={<StripeOnboardingReturnPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
